import { Circle, Database, Home, Info, Search, Send, Settings, User, Users } from "react-feather"
import icons from '../../assets/images/icons/icons'
const estados = [
  { uf: 'AC', nome: 'Acre' },
  { uf: 'AL', nome: 'Alagoas' },
  { uf: 'AP', nome: 'Amapá' },
  { uf: 'AM', nome: 'Amazonas' },
  { uf: 'BA', nome: 'Bahia' },
  { uf: 'CE', nome: 'Ceará' },
  { uf: 'DF', nome: 'Distrito Federal' },
  { uf: 'ES', nome: 'Espirito Santo' },
  { uf: 'GO', nome: 'Goiás' },
  { uf: 'MA', nome: 'Maranhão' },
  { uf: 'MS', nome: 'Mato Grosso do Sul' },
  { uf: 'MT', nome: 'Mato Grosso' },
  { uf: 'MG', nome: 'Minas Gerais' },
  { uf: 'PA', nome: 'Pará' },
  { uf: 'PB', nome: 'Paraíba' },
  { uf: 'PR', nome: 'Paraná' },
  { uf: 'PE', nome: 'Pernambuco' },
  { uf: 'PI', nome: 'Piauí' },
  { uf: 'RJ', nome: 'Rio de Janeiro' },
  { uf: 'RN', nome: 'Rio Grande do Norte' },
  { uf: 'RS', nome: 'Rio Grande do Sul' },
  { uf: 'RO', nome: 'Rondônia' },
  { uf: 'RR', nome: 'Roraima' },
  { uf: 'SC', nome: 'Santa Catarina' },
  { uf: 'SP', nome: 'São Paulo' },
  { uf: 'SE', nome: 'Sergipe' },
  { uf: 'TO', nome: 'Tocantins' }
]
const estadosSemBase = ["AM", "AC", "RR"]
const estadosST = []
const estadosDIFAL = []
estados.map((item) => {
  estadosST.push({
    title: item.nome,
    id: item.uf,
    icon: <Circle size={12} />,
    navLink: `/icmsst/${item.uf.toLowerCase()}`,
    disabled: estadosSemBase.some(element => element === item.uf)
  })
  estadosDIFAL.push({
    title: item.nome,
    id: item.uf,
    icon: <Circle size={12} />,
    navLink: `/difal/${item.uf.toLowerCase()}`,
    disabled: estadosSemBase.some(element => element === item.uf)
  })
})
export default [
  {
    id: 'home',
    title: <h1 className='menuItens'>Pagina Inicial</h1>,
    icon: <Home className='menuIcon' size={20} />,
    navLink: '/home'
  },
  {
    id: 'perfl',
    title: <h1 className='menuItens'>Perfil</h1>,
    icon: <User className='menuIcon' size={20} />,
    navLink: '/perfil'
  },
  {
    id: 'users',
    title: <h1 className='menuItens'>Usuários</h1>,
    icon: <Users className='menuIcon' size={20} />,
    navLink: "/users"
  },

  {
    id: 'base',
    title: <h1 className='menuItens'>Base</h1>,
    icon: <Database className='menuIcon' size={20} />
  }
]
